module.exports = __webpack_public_path__ + "img/icn_entrevistapaga_25.8d4b51b9.svg";